var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#528AEA",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0H.583A.583.583 0 0 0 0 .583V5.25c0 .323.261.583.583.583H5.25c.322 0 .583-.26.583-.583V.583A.583.583 0 0 0 5.25 0zM13.417 0H8.75a.583.583 0 0 0-.583.583V5.25c0 .323.261.583.583.583h4.667c.322 0 .583-.26.583-.583V.583A.583.583 0 0 0 13.417 0zM5.25 8.167H.583A.583.583 0 0 0 0 8.75v4.667c0 .322.261.583.583.583H5.25c.322 0 .583-.26.583-.583V8.75a.583.583 0 0 0-.583-.583zM13.417 8.167H8.75a.583.583 0 0 0-.583.583v4.667c0 .322.261.583.583.583h4.667c.322 0 .583-.26.583-.583V8.75a.583.583 0 0 0-.583-.583z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.ba5450e3337867e81d1c37a901ef7d0f.svg";
export { ForwardRef as ReactComponent };